// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ff-0";